import { ToggleControl } from "@nextgis/react-ngw-map";
import type { ControlOptions, ToggleControlOptions } from "@nextgis/webmap";

import { useTranslation } from "../../i18n";
import { IdentifyIcon } from "../map-tools/icons";

type ToolIdentifyProps = Omit<
  ToggleControlOptions,
  "html" | "onClick" | "title" | "status"
> &
  ControlOptions & {
    active: boolean;
    onActiveChange: (active: boolean) => void;
  };

export function ToolIdentify({
  active,
  onActiveChange,
  ...controlProps
}: ToolIdentifyProps) {
  const { t } = useTranslation();

  return (
    <ToggleControl
      {...controlProps}
      status={active}
      title={t("tools.identify")}
      onClick={onActiveChange}
    >
      <IdentifyIcon className="tool-svg" />
    </ToggleControl>
  );
}
